import { WSBaseMidBack } from './base';

/**
 * @internal
 */
export class WsMidbackPortalThread extends WSBaseMidBack {
  openThreadHubSocket() {
    return this.build('/threadhub');
  }
}
